import { Pipe, PipeTransform } from '@angular/core';
import { restoreSavedSearchCombineRulesValue } from '../../../misc/saved-searches/helpers/prepare-saved-search-rule-values.helper';
@Pipe({ name: 'ssCombineRulesView', pure: true })
export class SavedSearchCombineRulesViewPipe implements PipeTransform {

    transform(ruleCombination: string, ruleData: any[]): any {
        if(!ruleCombination || !ruleData?.length) return null;

        return restoreSavedSearchCombineRulesValue(ruleCombination,ruleData);
    }

 }
